import {
    getSelectedTableView,
    getRowKeysFromRowIds,
    MailRowDataPropertyGetter,
    isConversationView,
} from 'owa-mail-list-store';

export default function getLatestNonDraftItemIdFromTableView(
    conversationId?: string,
    itemId?: string
): string {
    const tableView = getSelectedTableView();
    const isConversationListViewType = isConversationView(tableView);
    const rowId = isConversationListViewType ? conversationId : itemId;
    const rowKeys = getRowKeysFromRowIds([rowId], tableView);
    const globalItemIds = MailRowDataPropertyGetter.getGlobalItemIds(rowKeys[0], tableView);
    const draftItemIds = MailRowDataPropertyGetter.getDraftItemIds(rowKeys[0], tableView);
    let latestGlobalItemId: string = null;
    for (let i = 0; i < globalItemIds.length; i++) {
        if (draftItemIds.indexOf(globalItemIds[i]) === -1) {
            latestGlobalItemId = globalItemIds[i];
            break;
        }
    }
    return latestGlobalItemId;
}
